import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CITIES, EMAIL, PHONE_DISPLAY, PHONE_HREF, ARCEUS_URL } from '../data/site';
import { track, EVENTS } from '../utils/analytics';

const YEAR = new Date().getFullYear();

const mark = (
  <img
    src="/brand/logo-full-flat.png"
    alt="JK Automations"
    width={73}
    height={40}
  />
);

/**
 * Two footers, one per breakpoint. Desktop keeps two short link columns.
 * Phones get the compact block: mark, one line, two full-width actions,
 * one row of links - no stacked column lists.
 */
const Footer: React.FC = () => {
  const { pathname } = useLocation();
  const contactAlreadyShown = pathname === '/' || pathname === '/contact';
  return (
  <footer className="site-footer">
    <div className="shell">
      <div className="site-footer__grid">
        <div className="site-footer__brand">
          <Link to="/" className="wordmark">
            {mark}
          </Link>
          <p>
            A marketing firm for small and service businesses in {CITIES}. We run the ads, answer
            the phone, and send the report.
          </p>
        </div>

        <div>
          <h2>Get in touch</h2>
          <ul>
            <li>
              <a
                href={`mailto:${EMAIL}`}
                onClick={() => track(EVENTS.emailClicked, { location: 'footer' })}
              >
                {EMAIL}
              </a>
            </li>
            <li>
              <a
                href={`tel:${PHONE_HREF}`}
                onClick={() => track(EVENTS.phoneClicked, { location: 'footer' })}
              >
                {PHONE_DISPLAY}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h2>More</h2>
          <ul>
            <li>
              <Link to="/work">Work</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <a href={ARCEUS_URL} target="_blank" rel="noopener noreferrer">
                Arceus
              </a>
            </li>
            <li>
              <Link to="/privacy">Privacy</Link>
            </li>
            <li>
              <Link to="/terms">Terms</Link>
            </li>
            <li>
              <Link to="/data-deletion">Data deletion</Link>
            </li>
          </ul>
        </div>
      </div>

      <p className="site-footer__base">
        © {YEAR} JK Automations LLC. Los Angeles &amp; San Diego, California.
      </p>

      <div className="site-footer__compact">
        <Link to="/" className="wordmark">
          {mark}
        </Link>
        <p>A marketing firm for small businesses in {CITIES}.</p>

        {!contactAlreadyShown && <div className="footer-actions">
          <a
            className="button button--primary button--wide"
            href={`mailto:${EMAIL}`}
            onClick={() => track(EVENTS.emailClicked, { location: 'footer-mobile' })}
          >
            Email us
          </a>
          <a
            className="button button--quiet button--wide"
            href={`tel:${PHONE_HREF}`}
            onClick={() => track(EVENTS.phoneClicked, { location: 'footer-mobile' })}
          >
            {PHONE_DISPLAY}
          </a>
        </div>}

        <nav className="footer-links" aria-label="Footer">
          <Link to="/work">Work</Link>
          <Link to="/about">About</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/data-deletion">Data deletion</Link>
        </nav>

        <small>© {YEAR} JK Automations LLC</small>
      </div>
    </div>
  </footer>
  );
};

export default React.memo(Footer);
